import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import { showErrorMessages } from "helpers/helpers"

import { GET_ALL_PRODUCT_CHANNELS } from "./actionTypes"
import { changePreloader } from "../../store/layout/actions"
import { getAllProductsChannelsCall } from "../../helpers/repository"
import {
  getAllProductChannels,
  getAllProductChannelsResponseSuccess,
} from "./actions"
function* attemptGetAllProductChannels() {
  try {
    yield put(changePreloader(true))
    const response = yield call(getAllProductsChannelsCall)
    yield put(
      getAllProductChannelsResponseSuccess(response.data.data.product_channels)
    )
    yield put(changePreloader(false))
  } catch (error) {
    showErrorMessages(error)
  }
}

function* ProductsChannelsSaga() {
  yield takeEvery(GET_ALL_PRODUCT_CHANNELS, attemptGetAllProductChannels)
}

export default ProductsChannelsSaga
